import React, { Fragment } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function FlowDiagramMockup() {
  const steps = [{
    number: 1,
    title: 'Connect your Kit.com account',
    icon: '🔗',
    description: 'Secure, read-only connection to your newsletter data.'
  }, {
    number: 2,
    title: 'Auto-tag & segment',
    icon: '🤖',
    description: 'Subscribers are grouped by topics, links, and products they engage with.'
  }, {
    number: 3,
    title: 'Use segments for content & sponsors',
    icon: '📊',
    description: 'Send targeted emails and generate sponsor-ready segment stats.'
  }];
  return <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-8 w-full" data-id="element-216">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-217">
                {steps.map((step, index) => <Fragment key={step.number} data-id="element-218">
                        {/* Step Card */}
                        <div className="flex-1 w-full" data-id="element-219">
                            <div className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-xl p-6 text-center transition-all hover:border-blue-600 hover:shadow-md" data-id="element-220">
                                {/* Step Number */}
                                <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 text-white rounded-full text-2xl font-bold mb-4" data-id="element-221">
                                    {step.number}
                                </div>

                                {/* Icon */}
                                <div className="text-4xl mb-3" data-id="element-222">{step.icon}</div>

                                {/* Title */}
                                <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-223">
                                    {step.title}
                                </h4>

                                {/* Description */}
                                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-224">
                                    {step.description}
                                </p>
                            </div>
                        </div>

                        {/* Arrow (not after last step) */}
                        {index < steps.length - 1 && <div className="hidden md:block flex-shrink-0" data-id="element-225">
                                <ArrowRightIcon className="w-8 h-8 text-blue-600" data-id="element-226" />
                            </div>}

                        {/* Mobile Arrow */}
                        {index < steps.length - 1 && <div className="md:hidden" data-id="element-227">
                                <ArrowRightIcon className="w-6 h-6 text-blue-600 rotate-90" data-id="element-228" />
                            </div>}
                    </Fragment>)}
            </div>

            {/* Bottom Summary */}
            <div className="mt-8 pt-6 border-t border-gray-200 text-center" data-id="element-229">
                <p className="text-sm text-gray-600" data-id="element-230">
                    <span className="font-semibold text-gray-900" data-id="element-231">
                        End-to-end automation:
                    </span>{' '}
                    From raw data to sponsor-ready insights in minutes
                </p>
            </div>
        </div>;
}